import React from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import Slider from "react-slick"
import { graphql, useStaticQuery } from "gatsby"
import { withTranslation } from "gatsby-plugin-react-i18next"
import ProductCard from "../Plp/ProductList/ProductCard"
import { mapProductsWithImages } from "../../services/images"

const CollectionCard = styled.div`
  position: relative;
  width: 288px !important;
  @media (min-width: ${breakpoints.lg}) {
    width: auto !important;
  }
`

const StyledSlider = styled(Slider)`
  margin: auto;
  max-width: ${breakpoints.xxl};

  .slick-list {
    padding-left: 20px;
  }
  .slick-slide {
    margin: 0 16px;
  }

  .slick-track {
    display: flex;
  }

  @media (min-width: ${breakpoints.md}) {
    .slick-list {
      padding-left: 32px;
    }
  }
  @media (min-width: ${breakpoints.lg}) {
    .slick-list {
      width: calc(100% + 32px);
      margin-left: -16px;
      padding-left: 0;
    }
  }
`

const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  fade: false,
  swipe: true,
  swipeToSlide: true,
  draggable: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  initialSlide: 0,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
  ],
}

const GET_PRODUCTS = graphql`
  query {
    kaia: shopifyProduct(handle: { eq: "kaia-earring" }) {
      ...ProductCardFragment
    }
    duo: shopifyProduct(handle: { eq: "duo-necklace" }) {
      ...ProductCardFragment
    }
    semihoop: shopifyProduct(handle: { eq: "semi-hoop-earring" }) {
      ...ProductCardFragment
    }
    astragalactic: shopifyProduct(handle: { eq: "astra-galactic-ring" }) {
      ...ProductCardFragment
    }
    unitybracelet: shopifyProduct(handle: { eq: "unity-men-bracelet" }) {
      ...ProductCardFragment
    }
  }
`

const CollectionCarousel = ({ t, products = null }) => {
  const data = useStaticQuery(GET_PRODUCTS)
  const result = Object.entries(data).map(([k, v]) => v)
  const filteredProducts = mapProductsWithImages([...result])

  return (
    <StyledSlider {...settings}>
      {filteredProducts &&
        filteredProducts.map((product, index) => (
          <CollectionCard key={index}>
            <ProductCard product={product} />
          </CollectionCard>
        ))}
    </StyledSlider>
  )
}

export default withTranslation()(CollectionCarousel)
